import { useCallback, useEffect, useState } from 'react';

import { fetchCurrentUser } from '../api';
import type { CurrentUser } from '../api';

export type AuthState =
  { kind: 'loading' } | { kind: 'anonymous' } | { kind: 'signed-in'; user: CurrentUser };

/**
 * Asks the API who is signed in. Without this the app always showed the login
 * form, even when a valid session cookie was present.
 */
export function useCurrentUser(): { state: AuthState; refresh: () => void } {
  const [state, setState] = useState<AuthState>({ kind: 'loading' });

  const refresh = useCallback(() => {
    setState({ kind: 'loading' });
    void fetchCurrentUser()
      .then((user) => setState(user ? { kind: 'signed-in', user } : { kind: 'anonymous' }))
      .catch(() => setState({ kind: 'anonymous' }));
  }, []);

  useEffect(refresh, [refresh]);

  return { state, refresh };
}
